/**
 * TEXTE VON VERWALTUNG › FÄLLIGKEITSTICKETS (Terminebene 12, D19, D28) — EINE Tabelle für Bereich, Tabelle, Panel und
 * Hinweise; Schlüssel englisch, Werte deutsch. Die Quellwörter stehen in `DUE_ITEM_TEXT.chipLabel`, die Befunde des
 * Servers (422, 409) kommen mit seinem Wortlaut an die Felder.
 */

/** `2026-11-01` → `01.11.2026`. */
const dayText = (day: string): string => `${day.slice(8, 10)}.${day.slice(5, 7)}.${day.slice(0, 4)}`;

export const DUE_TICKET_SETTING_TEXT = {
  area: "Fälligkeitstickets",
  loading: "Lädt …",
  loadFailed: "Die Einstellungen konnten nicht geladen werden.",
  empty: "Keine Unternehmen.",
  columns: { company: "Unternehmen", state: "Zustand", leadDays: "Vorlauf", sources: "Quellen", team: "Team" },
  on: (since: string | null): string => (since === null ? "an" : `an seit ${dayText(since)}`),
  off: "aus",
  leadDaysShort: (n: number): string => `${n} T`,
  none: "–",
  /** Das Team der Einstellung ist nicht mehr unter den aktiven (stillgelegt). */
  teamInactive: "(stillgelegt)",
  /** Ein Team, das für Lieferantenquellen nicht mehr taugt, bleibt in der Auswahl sichtbar, damit der Stand lesbar ist. */
  teamIncomplete: (name: string): string => `${name} (ohne vollständige Lieferantensicht)`,
  /** Kennzeichen in der Tabelle (H2): Der Nachtlauf lässt die Lieferantenquellen für dieses Team aus. */
  supplierViewIncomplete: "Lieferantenquellen ohne Ticket: Team ohne vollständige Lieferantensicht",
  edit: "Bearbeiten",
  editNamed: (code: string): string => `Fälligkeitstickets ${code} bearbeiten`,
  panelTitle: (code: string, name: string): string => `Fälligkeitstickets ${code} ${name}`,
  fields: { enabled: "Fälligkeitstickets anlegen", leadDays: "Vorlauf", sources: "Quellen", team: "Team" },
  leadDaysUnit: "Tage",
  leadDaysInvalid: "Der Vorlauf muss 0 bis 60 Tage betragen.",
  noTeam: "Kein Team",
  /** D28: der Hinweis im Panel. */
  hint: "Erfasst werden Fälligkeiten ab dem Einschalttag; ältere Überfällige bekommen kein Ticket. "
    + "Tickets aus Lieferantenquellen sind privat im Team.",
  /** Das Team braucht für Lieferantenquellen die vollständige Lieferantensicht (Hilfe am Feld). */
  teamHelp: "Mit Lieferantenquellen nur Teams, deren Mitglieder alle die Lieferantensicht haben.",
} as const;
